module.exports = __webpack_public_path__ + "img/Kenya.ad570683.gif";